import './calendar-day-event.style.sass';
import template from './calendar-day-event.tpl.pug';
import receiptIcon from './image/icon-image.svg';

class CalendarDayEventController {
    /* @ngInject */
    constructor(eventUtil, $element, $timeout, $window) {
        this.eventUtil = eventUtil;
        this.$element = $element;
        this.$timeout = $timeout;
        this.$window = $window;
        this.receiptIconUrl = `url(${receiptIcon})`;
        this.detailTooltip = null;
        this.tooltipUpdatePromise = null;
        this.receiptPreviewElement = null;
    }

    $onChanges(changeObject) {
        if (changeObject.confirmed || changeObject.category) {
            this.backgroundColor = this.confirmed && this.category ? this.category.color : null;
        }
        if (changeObject.type || changeObject.value || changeObject.note || changeObject.category || changeObject.details || changeObject.repeat || changeObject.receiptUrl) {
            this.actualValue = this.eventUtil.getValue(this.type, this.value);
            this.mainLabel = this.note || this.category && this.category.name || (this.type === 'income' ? 'income' : 'expense');
            this.detailNote = this.details && this.details.trim() ? this.details : null;
            this.receiptPreviewVisible = false;
            this.scheduleDetailTooltipUpdate();
        }
    }

    $postLink() {
        this.scheduleDetailTooltipUpdate();
    }

    $onDestroy() {
        if (this.tooltipUpdatePromise) {
            this.$timeout.cancel(this.tooltipUpdatePromise);
            this.tooltipUpdatePromise = null;
        }

        this.hideReceiptPreview();
    }

    scheduleDetailTooltipUpdate() {
        if (this.tooltipUpdatePromise) {
            this.$timeout.cancel(this.tooltipUpdatePromise);
        }
        this.tooltipUpdatePromise = this.$timeout(() => {
            this.tooltipUpdatePromise = null;
            this.updateDetailTooltip();
        });
    }

    updateDetailTooltip() {
        if (!this.detailNote) {
            this.detailTooltip = null;
            return;
        }
        const detailElement = this.$element[0].querySelector('.day-event-detail');
        const isTruncated = detailElement && detailElement.scrollWidth > detailElement.clientWidth;
        this.detailTooltip = isTruncated ? this.detailNote : null;
    }

    showReceiptPreview(event) {
        if (!this.receiptUrl || !event || !event.currentTarget) {
            return;
        }

        this.hideReceiptPreview();

        const previewElement = this.$window.document.createElement('div');
        previewElement.className = 'calendar-day-event-receipt-hover-preview';

        const imageElement = this.$window.document.createElement('img');
        imageElement.className = 'calendar-day-event-receipt-hover-preview-image';
        imageElement.src = this.receiptUrl;
        imageElement.alt = 'Receipt preview';

        previewElement.appendChild(imageElement);
        this.$window.document.body.appendChild(previewElement);
        this.receiptPreviewElement = previewElement;

        this.positionReceiptPreview(event.currentTarget);
    }

    hideReceiptPreview() {
        if (this.receiptPreviewElement && this.receiptPreviewElement.parentNode) {
            this.receiptPreviewElement.parentNode.removeChild(this.receiptPreviewElement);
        }

        this.receiptPreviewElement = null;
    }

    positionReceiptPreview(target) {
        if (!this.receiptPreviewElement || !target || !target.getBoundingClientRect) {
            return;
        }

        const previewSize = 240;
        const previewPadding = 4;
        const previewWidth = previewSize + previewPadding * 2;
        const previewHeight = previewSize + previewPadding * 2;
        const spacing = 8;
        const viewportMargin = 8;

        const targetRect = target.getBoundingClientRect();
        const viewportWidth = this.$window.innerWidth || 0;
        const viewportHeight = this.$window.innerHeight || 0;

        let left = targetRect.left + targetRect.width / 2 - previewWidth / 2;
        left = Math.max(viewportMargin, Math.min(left, viewportWidth - previewWidth - viewportMargin));

        let top = targetRect.top - previewHeight - spacing;

        if (top < viewportMargin) {
            top = targetRect.bottom + spacing;
        }

        if (top + previewHeight > viewportHeight - viewportMargin) {
            top = Math.max(viewportMargin, viewportHeight - previewHeight - viewportMargin);
        }

        this.receiptPreviewElement.style.left = `${left}px`;
        this.receiptPreviewElement.style.top = `${top}px`;
    }
}

export default {
    selector: 'dbACalendarDayEvent',
    template: template(),
    controller: CalendarDayEventController,
    bindings: {
        type: '<',
        confirmed: '<',
        category: '<',
        note: '<',
        details: '<',
        value: '<',
        repeat: '<',
        receiptUrl: '<',
        useCategoryIcons: '<'
    }
};



// WEBPACK FOOTER //
// ./src/application/scene/authorized/scene/calendar/component/calendar-day/component/calendar-day-event/calendar-day-event.cmpt.js